<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3 md4 offset-md4>
        <div class="my-5 display-1">Registracija</div>
        <v-form v-on:submit.prevent="register">
          <p v-if="info" :value="true" type="info" v-text="info" class="multi-line mb-4"></p>
          <v-btn-toggle class="mb-4" v-model="accountType" mandatory style="width: 100%">
            <v-btn large block width="33%" v-for="(accountType, i) in accountTypes" :value="accountType.type" :key="i" class="primary">
              {{accountType.label}}
            </v-btn>
          </v-btn-toggle>
          <v-text-field v-model="name" :label="accountType=='courier'?'ime i prezime':'naziv'" required ref="name"></v-text-field>
          <v-text-field v-model="phone" label="telefon" required autocomplete="phone" ref="phone"></v-text-field>
          <v-text-field v-model="email" label="email" required autocomplete="email" ref="email"></v-text-field>
          <v-text-field v-model="password" label="lozinka" required autocomplete="new-password"
            :append-icon="showPassword ? 'visibility' : 'visibility_off'" @click:append="() => (showPassword = !showPassword)"
            :type="showPassword ? 'text' : 'password'"></v-text-field>
          <v-text-field v-model="confirmPassword" label="potvrda lozinke" required autocomplete="new-password"
            :append-icon="showPassword ? 'visibility' : 'visibility_off'" @click:append="() => (showPassword = !showPassword)"
            :type="showPassword ? 'text' : 'password'"></v-text-field>
          <v-alert v-if="success" :value="true" type="success" v-text="success" class="multi-line"></v-alert>
          <v-btn class="primary my-5" large block type="submit" :disabled="!valid" :loading="loading">registracija</v-btn>
          <v-alert v-if="error" :value="true" type="error" v-text="error"></v-alert>
          <p><router-link to="/login">login</router-link></p>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import auth from '@/services/authService.js'
const accountTypes = [
  { type: 'store', label: 'Radnja' },
  { type: 'courier', label: 'Kurir' },
  { type: 'proxy', label: 'Agencija' }
]
export default {
  data () {
    return {
      accountTypes,
      accountType: accountTypes[0].type,
      name: '',
      phone: '',
      email: '',
      password: '',
      confirmPassword: '',
      showPassword: false,
      valid: true,
      loading: false,
      info: `Lozinka mora imati minimum 8 karaktera, malo, veliko slovo i broj.
      Telefon mora biti u obliku +3816xxxxxxx
      Nakon potvrde email adrese potrebno je i da administrator odobri nalog.`,
      error: '',
      success: ''
    }
  },
  created () {
    this.$nextTick(() => this.$refs.name.focus())
  },
  methods: {
    register () {
      let vm = this
      this.loading = true
      auth.register(vm.email.toLowerCase().trim(), vm.password, vm.accountType, vm.name, vm.phone, function () {
        vm.loading = false
        vm.error = ''
        vm.success = 'Na datu adresu je poslat email sa linkom koji je potrebno otvoriti da bi se potvrdila email adresa'
      }, function (err) {
        vm.error = vm.translateError(err)
        vm.loading = false
      })
    },
    translateError (err) {
      console.log(err)
      if (err.code === 'UsernameExistsException') {
        return 'Nalog sa email adresom koju ste uneli već postoji'
      } else if (err.code === 'InvalidPasswordException' || (err.code === 'InvalidParameterException' && err.message.indexOf('password') !== -1)) {
        return 'Lozinka nije dovoljno složena'
      } else if (err.code === 'InvalidParameterException' && err.message.indexOf('phone number') !== -1) {
        return 'Telefon mora biti u obliku +3816xxxxxxx'
      } else {
        return 'Greška pri registraciji'
      }
    }
  }
}

</script>

<style scoped>
.multi-line {
  white-space: pre-line;
}

</style>
